import React from 'react';
import Pagination from './Pagination';
import { TABLE_ITEMS_PER_PAGE } from '../hooks/useTablePagination';

const TablePagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage = TABLE_ITEMS_PER_PAGE,
  onPageChange,
  className = 'table-pagination'
}) => {
  if (totalPages <= 1) return null;

  return (
    <div className={className}>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalItems}
        itemsPerPage={itemsPerPage}
        onPageChange={onPageChange}
        showPageSizeSelector={false}
      />
    </div>
  );
};

export default TablePagination;
